export type CustomerPotentialDetail = {
  customerName: string | null;
  customerEmail: string | null;
  potentialId: string | null;
  planType: string | null;
  location: string | null;
  stage?: string | null;
  error?: string | null;
};

export type CustomerPotentialDetailAction =
  | {
      type: "UPDATE_FIELD";
      payload: {
        field: string;
        value: any;
      };
    }
  | {
      type: "UPDATE_MULTIPLE_FIELDS";
      payload: Partial<CustomerPotentialDetail> | {};
    };

export const customerPotentialDetailInitialState: CustomerPotentialDetail = {
  customerName: null,
  customerEmail: null,
  potentialId: null,
  planType: null,
  location: null,
  stage: null,
  error: null,
};

export function customerPotentialDetailReducer(
  state: CustomerPotentialDetail,
  action: CustomerPotentialDetailAction
): CustomerPotentialDetail {
  switch (action.type) {
    case "UPDATE_FIELD":
      console.log(
        `Updating ${action.payload.field} in CustomerPotentialDetail with: ${action.payload.value}`
      );
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    case "UPDATE_MULTIPLE_FIELDS":
      console.log(`Updating multiple fields in CustomerPotentialDetail`);
      return {
        ...state,
        ...action.payload,
      };
    default:
      console.log(`Error - incorrect action sent ${action} ${state}`);
      return state;
  }
}
